import { axios } from '@/utils/request'
/**
 * 获取消息未读总数
 */
export function getNumber (params) {
  return axios({
    url: '/finsaas-mcs/navi/unread-count',
    method: 'post',
    data: params
  })
}
